import { useQuery } from '@tanstack/react-query';
import { Response } from 'routes/HumanResourcesModule/business/types';
import { RQAPICallWithData } from 'store/APIClient';
import { SIMULATION_ENDPOINT_PREFIX } from 'routes/HumanResourcesModule/Simulation/helpers/constants';
import { SimulationPayComponentsData } from '../definitions';

export const HR_SIMULATION_PAY_COMPONENTS_DATA_API_KEY = 'pay_components';

export const useGetHrSimulationPayComponentsData = (hrSimulationId: number) =>
    useQuery({
        queryKey: [HR_SIMULATION_PAY_COMPONENTS_DATA_API_KEY, hrSimulationId],

        queryFn: async () => {
            const response = await RQAPICallWithData<
                Response<SimulationPayComponentsData>
            >({
                endpoint: `${SIMULATION_ENDPOINT_PREFIX}/${hrSimulationId}/pay_components/simulation_data`,
            });
            return response.content.data;
        },
    });
